// Backgrounds / Black
exports.black = "#050505";

// Transparents / Black / 00-Black-Light (70%)
exports.blackLight = "rgba(5,5,5,0.7)";

// Transparents / Black / 01-Black-Xlight (40%)
exports.blackXLight = "rgba(5,5,5,0.4)";

// Transparents / Black / 02-Black-Xxlight (10%)
exports.blackXXLight = "rgba(5,5,5,0.1)";

// Backgrounds / Blue / Blue-00 (Xxdark)
exports.blue00 = "#00101f";

// Backgrounds / Blue / Blue-01
exports.blue01 = "#05192b";

// Backgrounds / Blue / Blue-02
exports.blue02 = "#092743";

// Backgrounds / Blue / Blue-03 (Xdark)
exports.blue03 = "#0d365c";

// Backgrounds / Blue / Blue-04
exports.blue04 = "#12487a";

// Backgrounds / Blue / Blue-05 (Dark)
exports.blue05 = "#165b99";

// Backgrounds / Blue / Blue-06
exports.blue06 = "#1b6fb9";

// Backgrounds / Blue / -Blue-07 (Base)
exports.blue07 = "#1f83db";

// Backgrounds / Blue / Blue-08
exports.blue08 = "#5995e1";

// Backgrounds / Blue / Blue-09 (Light)
exports.blue09 = "#7ea7e7";

// Backgrounds / Blue / Blue-10
exports.blue10 = "#9dbaec";

// Backgrounds / Blue / Blue-11 (Xlight)
exports.blue11 = "#bacdf2";

// Backgrounds / Blue / Blue-12
exports.blue12 = "#d2def6";

// Backgrounds / Blue / Blue-13
exports.blue13 = "#eaf0fb";

// Backgrounds / Blue / Blue-14 (Xxlight)
exports.blue14 = "#f7fafd";

// Transparents / Blue / 00-Blue-Light (70%)
exports.blueLight = "rgba(31,131,219,0.7)";

// Transparents / Blue / 01-Blue-Xlight (40%)
exports.blueXLight = "rgba(31,131,219,0.4)";

// Transparents / Blue / 02-Blue-Xxlight (10%)
exports.blueXXLight = "rgba(31,131,219,0.1)";

// Backgrounds / Cyan / Cyan-00 (Xxdark)
exports.cyan00 = "#001b1e";

// Backgrounds / Cyan / Cyan-01
exports.cyan01 = "#042529";

// Backgrounds / Cyan / Cyan-02
exports.cyan02 = "#08373d";

// Backgrounds / Cyan / Cyan-03 (Xdark)
exports.cyan03 = "#0f4a52";

// Backgrounds / Cyan / Cyan-04
exports.cyan04 = "#17616c";

// Backgrounds / Cyan / Cyan-05 (Dark)
exports.cyan05 = "#207986";

// Backgrounds / Cyan / Cyan-06
exports.cyan06 = "#2991a2";

// Backgrounds / Cyan / -Cyan-07 (Base)
exports.cyan07 = "#32abbe";

// Backgrounds / Cyan / Cyan-08
exports.cyan08 = "#5fb8c8";

// Backgrounds / Cyan / Cyan-09 (Light)
exports.cyan09 = "#80c5d2";

// Backgrounds / Cyan / Cyan-10
exports.cyan10 = "#9ed2dc";

// Backgrounds / Cyan / Cyan-11 (Xlight)
exports.cyan11 = "#badfe6";

// Backgrounds / Cyan / Cyan-12
exports.cyan12 = "#d2eaef";

// Backgrounds / Cyan / Cyan-13
exports.cyan13 = "#eaf5f8";

// Backgrounds / Cyan / Cyan-14 (Xxlight)
exports.cyan14 = "#f7fcfd";

// Transparents / Cyan / 00-Cyan-Light (70%)
exports.cyanLight = "rgba(50,171,190,0.7)";

// Transparents / Cyan / 01-Cyan-Xlight (40%)
exports.cyanXLight = "rgba(50,171,190,0.4)";

// Transparents / Cyan / 02-Cyan-Xxlight (10%)
exports.cyanXXLight = "rgba(50,171,190,0.1)";

// Backgrounds / Grape / Grape-00 (Xxdark)
exports.grape00 = "#18001f";

// Backgrounds / Grape / Grape-01
exports.grape01 = "#200b2a";

// Backgrounds / Grape / Grape-02
exports.grape02 = "#33143f";

// Backgrounds / Grape / Grape-03 (Xdark)
exports.grape03 = "#481d56";

// Backgrounds / Grape / Grape-04
exports.grape04 = "#602871";

// Backgrounds / Grape / Grape-05 (Dark)
exports.grape05 = "#7a338d";

// Backgrounds / Grape / Grape-06
exports.grape06 = "#943eab";

// Backgrounds / Grape / -Grape-07 (Base)
exports.grape07 = "#b04ac9";

// Backgrounds / Grape / Grape-08
exports.grape08 = "#be68d2";

// Backgrounds / Grape / Grape-09 (Light)
exports.grape09 = "#cb84da";

// Backgrounds / Grape / Grape-10
exports.grape10 = "#d89fe3";

// Backgrounds / Grape / Grape-11 (Xlight)
exports.grape11 = "#e4baeb";

// Backgrounds / Grape / Grape-12
exports.grape12 = "#edd2f2";

// Backgrounds / Grape / Grape-13
exports.grape13 = "#f7e9f9";

// Backgrounds / Grape / Grape-14 (Xxlight)
exports.grape14 = "#fcf7fd";

// Transparents / Grape / 00-Grape-Light (70%)
exports.grapeLight = "rgba(176,74,201,0.7)";

// Transparents / Grape / 01-Grape-Xlight (40%)
exports.grapeXLight = "rgba(176,74,201,0.4)";

// Transparents / Grape / 02-Grape-Xxlight (10%)
exports.grapeXXLight = "rgba(176,74,201,0.1)";

// Backgrounds / Gray / Gray-00 (Xxdark)
exports.gray00 = "#0f0f0f";

// Backgrounds / Gray / Gray-01
exports.gray01 = "#181818";

// Backgrounds / Gray / Gray-02
exports.gray02 = "#242424";

// Backgrounds / Gray / Gray-03 (Xdark)
exports.gray03 = "#323232";

// Backgrounds / Gray / Gray-04
exports.gray04 = "#424242";

// Backgrounds / Gray / Gray-05 (Dark)
exports.gray05 = "#535353";

// Backgrounds / Gray / Gray-06
exports.gray06 = "#646464";

// Backgrounds / Gray / -Gray-07 (Base)
exports.gray07 = "#767676";

// Backgrounds / Gray / Gray-08
exports.gray08 = "#8a8a8a";

// Backgrounds / Gray / Gray-09 (Light)
exports.gray09 = "#9e9e9e";

// Backgrounds / Gray / Gray-10
exports.gray10 = "#b3b3b3";

// Backgrounds / Gray / Gray-11 (Xlight)
exports.gray11 = "#c8c8c8";

// Backgrounds / Gray / Gray-12
exports.gray12 = "#dbdbdb";

// Backgrounds / Gray / Gray-13
exports.gray13 = "#efefef";

// Backgrounds / Gray / Gray-14 (Xxlight)
exports.gray14 = "#fafafa";

// Transparents / Gray / 00-Gray-Light (70%)
exports.grayLight = "rgba(118,118,118,0.7)";

// Transparents / Gray / 01-Gray-Xlight (40%)
exports.grayXLight = "rgba(118,118,118,0.4)";

// Transparents / Gray / 02-Gray-Xxlight (10%)
exports.grayXXLight = "rgba(118,118,118,0.1)";

// Backgrounds / Green / Green-00 (Xxdark)
exports.green00 = "#121e00";

// Backgrounds / Green / Green-01
exports.green01 = "#192a07";

// Backgrounds / Green / Green-02
exports.green02 = "#28400f";

// Backgrounds / Green / Green-03 (Xdark)
exports.green03 = "#385714";

// Backgrounds / Green / Green-04
exports.green04 = "#4c731a";

// Backgrounds / Green / Green-05 (Dark)
exports.green05 = "#61911f";

// Backgrounds / Green / Green-06
exports.green06 = "#76af25";

// Backgrounds / Green / -Green-07 (Base)
exports.green07 = "#8ccf2a";

// Backgrounds / Green / Green-08
exports.green08 = "#a1d753";

// Backgrounds / Green / Green-09 (Light)
exports.green09 = "#b4de74";

// Backgrounds / Green / Green-10
exports.green10 = "#c6e593";

// Backgrounds / Green / Green-11 (Xlight)
exports.green11 = "#d7edb2";

// Backgrounds / Green / Green-12
exports.green12 = "#e5f3cd";

// Backgrounds / Green / Green-13
exports.green13 = "#f3f9e8";

// Backgrounds / Green / Green-14 (Xxlight)
exports.green14 = "#fbfdf7";

// Transparents / Green / 00-Green-Light (70%)
exports.greenLight = "rgba(140,207,42,0.7)";

// Transparents / Green / 01-Green-Xlight (40%)
exports.greenXLight = "rgba(140,207,42,0.4)";

// Transparents / Green / 02-Green-Xxlight (10%)
exports.greenXXLight = "rgba(140,207,42,0.1)";

// Backgrounds / Indigo / Indigo-00 (Xxdark)
exports.indigo00 = "#00071f";

// Backgrounds / Indigo / Indigo-01
exports.indigo01 = "#07122c";

// Backgrounds / Indigo / Indigo-02
exports.indigo02 = "#0f1e44";

// Backgrounds / Indigo / Indigo-03 (Xdark)
exports.indigo03 = "#192b5e";

// Backgrounds / Indigo / Indigo-04
exports.indigo04 = "#24397e";

// Backgrounds / Indigo / Indigo-05 (Dark)
exports.indigo05 = "#30499f";

// Backgrounds / Indigo / Indigo-06
exports.indigo06 = "#3c59c1";

// Backgrounds / Indigo / -Indigo-07 (Base)
exports.indigo07 = "#4969e4";

// Backgrounds / Indigo / Indigo-08
exports.indigo08 = "#6f7ee9";

// Backgrounds / Indigo / Indigo-09 (Light)
exports.indigo09 = "#8e94ed";

// Backgrounds / Indigo / Indigo-10
exports.indigo10 = "#a9abf1";

// Backgrounds / Indigo / Indigo-11 (Xlight)
exports.indigo11 = "#c2c2f5";

// Backgrounds / Indigo / Indigo-12
exports.indigo12 = "#d7d7f8";

// Backgrounds / Indigo / Indigo-13
exports.indigo13 = "#ebedfb";

// Backgrounds / Indigo / Indigo-14 (Xxlight)
exports.indigo14 = "#f7f9fd";

// Transparents / Indigo / 00-Indigo-Light (70%)
exports.indigoLight = "rgba(73,105,228,0.7)";

// Transparents / Indigo / 01-Indigo-Xlight (40%)
exports.indigoXLight = "rgba(73,105,228,0.4)";

// Transparents / Indigo / 02-Indigo-Xxlight (10%)
exports.indigoXXLight = "rgba(73,105,228,0.1)";

// Backgrounds / Lime / Lime-00 (Xxdark)
exports.lime00 = "#001f06";

// Backgrounds / Lime / Lime-01
exports.lime01 = "#05290f";

// Backgrounds / Lime / Lime-02
exports.lime02 = "#0c3c19";

// Backgrounds / Lime / Lime-03 (Xdark)
exports.lime03 = "#145124";

// Backgrounds / Lime / Lime-04
exports.lime04 = "#1f6930";

// Backgrounds / Lime / Lime-05 (Dark)
exports.lime05 = "#2a833c";

// Backgrounds / Lime / Lime-06
exports.lime06 = "#359e4a";

// Backgrounds / Lime / -Lime-07 (Base)
exports.lime07 = "#41b957";

// Backgrounds / Lime / Lime-08
exports.lime08 = "#65c470";

// Backgrounds / Lime / Lime-09 (Light)
exports.lime09 = "#84d08a";

// Backgrounds / Lime / Lime-10
exports.lime10 = "#a0dba3";

// Backgrounds / Lime / Lime-11 (Xlight)
exports.lime11 = "#bbe5bd";

// Backgrounds / Lime / Lime-12
exports.lime12 = "#d2efd4";

// Backgrounds / Lime / Lime-13
exports.lime13 = "#e9f8eb";

// Backgrounds / Lime / Lime-14 (Xxlight)
exports.lime14 = "#f6fdf8";

// Transparents / Lime / 00-Lime-Light (70%)
exports.limeLight = "rgba(65,185,87,0.7)";

// Transparents / Lime / 01-Lime-Xlight (40%)
exports.limeXLight = "rgba(65,185,87,0.4)";

// Transparents / Lime / 02-Lime-Xxlight (10%)
exports.limeXXLight = "rgba(65,185,87,0.1)";

// Backgrounds / Orange / Orange-00 (Xxdark)
exports.orange00 = "#1e0c00";

// Backgrounds / Orange / Orange-01
exports.orange01 = "#2b1505";

// Backgrounds / Orange / Orange-02
exports.orange02 = "#46210d";

// Backgrounds / Orange / Orange-03 (Xdark)
exports.orange03 = "#622e10";

// Backgrounds / Orange / Orange-04
exports.orange04 = "#853d12";

// Backgrounds / Orange / Orange-05 (Dark)
exports.orange05 = "#a94d14";

// Backgrounds / Orange / Orange-06
exports.orange06 = "#cf5d14";

// Backgrounds / Orange / -Orange-07 (Base)
exports.orange07 = "#f66e13";

// Backgrounds / Orange / Orange-08
exports.orange08 = "#fd853f";

// Backgrounds / Orange / Orange-09 (Light)
exports.orange09 = "#ff9c62";

// Backgrounds / Orange / Orange-10
exports.orange10 = "#ffb284";

// Backgrounds / Orange / Orange-11 (Xlight)
exports.orange11 = "#ffc8a7";

// Backgrounds / Orange / Orange-12
exports.orange12 = "#ffdbc5";

// Backgrounds / Orange / Orange-13
exports.orange13 = "#ffeee5";

// Backgrounds / Orange / Orange-14 (Xxlight)
exports.orange14 = "#fdf9f7";

// Transparents / Orange / 00-Orange-Light (70%)
exports.orangeLight = "rgba(246,110,19,0.7)";

// Transparents / Orange / 01-Orange-Xlight (40%)
exports.orangeXLight = "rgba(246,110,19,0.4)";

// Transparents / Orange / 02-Orange-Xxlight (10%)
exports.orangeXXLight = "rgba(246,110,19,0.1)";

// Backgrounds / Pear / Pear-00 (Xxdark)
exports.pear00 = "#1e1d00";

// Backgrounds / Pear / Pear-01
exports.pear01 = "#2a2a07";

// Backgrounds / Pear / Pear-02
exports.pear02 = "#42410e";

// Backgrounds / Pear / Pear-03 (Xdark)
exports.pear03 = "#5d5a12";

// Backgrounds / Pear / Pear-04
exports.pear04 = "#7c7815";

// Backgrounds / Pear / Pear-05 (Dark)
exports.pear05 = "#9d9718";

// Backgrounds / Pear / Pear-06
exports.pear06 = "#bfb71b";

// Backgrounds / Pear / -Pear-07 (Base)
exports.pear07 = "#e3d91c";

// Backgrounds / Pear / Pear-08
exports.pear08 = "#eade4f";

// Backgrounds / Pear / Pear-09 (Light)
exports.pear09 = "#f0e472";

// Backgrounds / Pear / Pear-10
exports.pear10 = "#f6e993";

// Backgrounds / Pear / Pear-11 (Xlight)
exports.pear11 = "#f9efb2";

// Backgrounds / Pear / Pear-12
exports.pear12 = "#fcf4cd";

// Backgrounds / Pear / Pear-13
exports.pear13 = "#fdf9e8";

// Backgrounds / Pear / Pear-14 (Xxlight)
exports.pear14 = "#fdfcf7";

// Transparents / Pear / 00-Pear-Light (70%)
exports.pearLight = "rgba(227,217,28,0.7)";

// Transparents / Pear / 01-Pear-Xlight (40%)
exports.pearXLight = "rgba(227,217,28,0.4)";

// Transparents / Pear / 02-Pear-Xxlight (10%)
exports.pearXXLight = "rgba(227,217,28,0.1)";

// Backgrounds / Pink / Pink-00 (Xxdark)
exports.pink00 = "#1e000a";

// Backgrounds / Pink / Pink-01
exports.pink01 = "#280a14";

// Backgrounds / Pink / Pink-02
exports.pink02 = "#3f1221";

// Backgrounds / Pink / Pink-03 (Xdark)
exports.pink03 = "#58192f";

// Backgrounds / Pink / Pink-04
exports.pink04 = "#75223f";

// Backgrounds / Pink / Pink-05 (Dark)
exports.pink05 = "#942b50";

// Backgrounds / Pink / Pink-06
exports.pink06 = "#b53461";

// Backgrounds / Pink / -Pink-07 (Base)
exports.pink07 = "#d63d73";

// Backgrounds / Pink / Pink-08
exports.pink08 = "#e06187";

// Backgrounds / Pink / Pink-09 (Light)
exports.pink09 = "#e87f9c";

// Backgrounds / Pink / Pink-10
exports.pink10 = "#f09cb1";

// Backgrounds / Pink / Pink-11 (Xlight)
exports.pink11 = "#f5b8c6";

// Backgrounds / Pink / Pink-12
exports.pink12 = "#f9d1da";

// Backgrounds / Pink / Pink-13
exports.pink13 = "#fce9ee";

// Backgrounds / Pink / Pink-14 (Xxlight)
exports.pink14 = "#fdf7f9";

// Transparents / Pink / 00-Pink-Light (70%)
exports.pinkLight = "rgba(214,61,115,0.7)";

// Transparents / Pink / 01-Pink-Xlight (40%)
exports.pinkXLight = "rgba(214,61,115,0.4)";

// Transparents / Pink / 02-Pink-Xxlight (10%)
exports.pinkXXLight = "rgba(214,61,115,0.1)";

// Backgrounds / Red / Red-00 (Xxdark)
exports.red00 = "#1e0002";

// Backgrounds / Red / Red-01
exports.red01 = "#2a0805";

// Backgrounds / Red / Red-02
exports.red02 = "#420e0b";

// Backgrounds / Red / Red-03 (Xdark)
exports.red03 = "#5d110f";

// Backgrounds / Red / Red-04
exports.red04 = "#7d1311";

// Backgrounds / Red / Red-05 (Dark)
exports.red05 = "#9e1313";

// Backgrounds / Red / Red-06
exports.red06 = "#c11014";

// Backgrounds / Red / -Red-07 (Base)
exports.red07 = "#e50914";

// Backgrounds / Red / Red-08
exports.red08 = "#f04c38";

// Backgrounds / Red / Red-09 (Light)
exports.red09 = "#f9715a";

// Backgrounds / Red / Red-10
exports.red10 = "#ff927d";

// Backgrounds / Red / Red-11 (Xlight)
exports.red11 = "#ffb2a2";

// Backgrounds / Red / Red-12
exports.red12 = "#ffcdc3";

// Backgrounds / Red / Red-13
exports.red13 = "#ffe8e4";

// Backgrounds / Red / Red-14 (Xxlight)
exports.red14 = "#fdf7f8";

// Transparents / Red / 00-Red-Light (70%)
exports.redLight = "rgba(229,9,20,0.7)";

// Transparents / Red / 01-Red-Xlight (40%)
exports.redXLight = "rgba(229,9,20,0.4)";

// Transparents / Red / 02-Red-Xxlight (10%)
exports.redXXLight = "rgba(229,9,20,0.1)";

// Backgrounds / Violet / Violet-00 (Xxdark)
exports.violet00 = "#08001e";

// Backgrounds / Violet / Violet-01
exports.violet01 = "#110b2b";

// Backgrounds / Violet / Violet-02
exports.violet02 = "#1d1643";

// Backgrounds / Violet / Violet-03 (Xdark)
exports.violet03 = "#2a1f5d";

// Backgrounds / Violet / Violet-04
exports.violet04 = "#3b297c";

// Backgrounds / Violet / Violet-05 (Dark)
exports.violet05 = "#4c349d";

// Backgrounds / Violet / Violet-06
exports.violet06 = "#5e3fbf";

// Backgrounds / Violet / -Violet-07 (Base)
exports.violet07 = "#714be2";

// Backgrounds / Violet / Violet-08
exports.violet08 = "#8c66e7";

// Backgrounds / Violet / Violet-09 (Light)
exports.violet09 = "#a481ec";

// Backgrounds / Violet / Violet-10
exports.violet10 = "#ba9cf1";

// Backgrounds / Violet / Violet-11 (Xlight)
exports.violet11 = "#ceb8f5";

// Backgrounds / Violet / Violet-12
exports.violet12 = "#dfd0f8";

// Backgrounds / Violet / Violet-13
exports.violet13 = "#f0e9fb";

// Backgrounds / Violet / Violet-14 (Xxlight)
exports.violet14 = "#f9f7fd";

// Transparents / Violet / 00-Violet-Light (70%)
exports.violetLight = "rgba(113,75,226,0.7)";

// Transparents / Violet / 01-Violet-Xlight (40%)
exports.violetXLight = "rgba(113,75,226,0.4)";

// Transparents / Violet / 02-Violet-Xxlight (10%)
exports.violetXXLight = "rgba(113,75,226,0.1)";

// Backgrounds / White
exports.white = "#FFFFFF";

// Transparents / White / 00-White-Light (70%)
exports.whiteLight = "rgba(255,255,255,0.7)";

// Transparents / White / 01-White-Xlight (40%)
exports.whiteXLight = "rgba(255,255,255,0.4)";

// Transparents / White / 02-White-Xxlight (10%)
exports.whiteXXLight = "rgba(255,255,255,0.1)";

// Backgrounds / Yellow / Yellow-00 (Xxdark)
exports.yellow00 = "#1e1400";

// Backgrounds / Yellow / Yellow-01
exports.yellow01 = "#2c1e06";

// Backgrounds / Yellow / Yellow-02
exports.yellow02 = "#47300d";

// Backgrounds / Yellow / Yellow-03 (Xdark)
exports.yellow03 = "#64430f";

// Backgrounds / Yellow / Yellow-04
exports.yellow04 = "#875a11";

// Backgrounds / Yellow / Yellow-05 (Dark)
exports.yellow05 = "#ac7210";

// Backgrounds / Yellow / Yellow-06
exports.yellow06 = "#d38a0c";

// Backgrounds / Yellow / -Yellow-07 (Base)
exports.yellow07 = "#fba404";

// Backgrounds / Yellow / Yellow-08
exports.yellow08 = "#ffb141";

// Backgrounds / Yellow / Yellow-09 (Light)
exports.yellow09 = "#ffbf66";

// Backgrounds / Yellow / Yellow-10
exports.yellow10 = "#ffcd89";

// Backgrounds / Yellow / Yellow-11 (Xlight)
exports.yellow11 = "#ffdbaa";

// Backgrounds / Yellow / Yellow-12
exports.yellow12 = "#ffe7c8";

// Backgrounds / Yellow / Yellow-13
exports.yellow13 = "#fff4e6";

// Backgrounds / Yellow / Yellow-14 (Xxlight)
exports.yellow14 = "#fdfbf7";

// Transparents / Yellow / 00-Yellow-Light (70%)
exports.yellowLight = "rgba(251,164,4,0.7)";

// Transparents / Yellow / 01-Yellow-Xlight (40%)
exports.yellowXLight = "rgba(251,164,4,0.4)";

// Transparents / Yellow / 02-Yellow-Xxlight (10%)
exports.yellowXXLight = "rgba(251,164,4,0.1)";
